import Pusher from 'pusher-js/react-native';

const createPusherClient = (token: string): Pusher => {
  return new Pusher('cce07f3a4de11ee272f4', {
    cluster: 'ap3',
    authEndpoint:
      'https://helpinghand.dev.bossdigital.tech/api/v1/broadcasting/auth',
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
};

export default createPusherClient;
